import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import styles from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      wrapper: {
        position: 'relative',
        width: '100%',
        overflow: 'initial',
        paddingTop: styles.paddingTopRatioHeight,
        maxHeight: 'initial',
        marginBottom: theme.spacing(2),
      },
      player: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        transitionProperty: 'width, height',
        transitionDuration: '150ms',
        transitionTimingFunction: 'ease-in-out',
        marginBottom: theme.spacing(2),
      },
      miniPlayer: {
        position: 'fixed',
        zIndex: 1200,
        [theme.breakpoints.up('xs')]: {
          width: 300,
          height: 197,
        },
        [theme.breakpoints.up('lg')]: {
          width: 360,
          height: 203,
        },
      },
    }),
  { name: 'Player' }
);
